import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY = { enabled: false, label: '', required: false, helpText: '', clientCanEdit: true };

/**
 * LOT B — Config de la référence externe applicable à l'utilisateur courant
 * (ou à une société donnée côté staff).
 */
export const useExternalReference = (company) => {
  const [config, setConfig] = useState(EMPTY);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const url = company
        ? `${API}/external-reference/config?company=${encodeURIComponent(company)}`
        : `${API}/external-reference/config`;
      const res = await axios.get(url);
      setConfig({ ...EMPTY, ...(res.data || {}) });
    } catch {
      setConfig(EMPTY);
    } finally {
      setLoading(false);
    }
  }, [company]);

  useEffect(() => { load(); }, [load]);

  return { config, loading, reload: load };
};

export default useExternalReference;
